import { useState, useEffect, useCallback } from "react";
import Storage from "../../services/Storage";
import "./Advert.scss";
import { Bling as GPT } from "react-gpt";
import { urlConstants } from "../../utils/urlConstants";
import { useSelector } from "react-redux";
import { Roles } from "../../utils/Roles";

GPT.enableSingleRequest();

const getSlotHeight = (width) => {
  if (width >= 1200) return 250;
  if (width >= 992) return 110;
  if (width >= 768) return 90;
  if (width >= 480) return 60;
  return 50;
};

function Advert() {
  const { API_URL } = urlConstants;
  const token = Storage.getTokenInCookie("token");
  const userData = useSelector((state) => state.UserReducer.userObj);

  const adDivId = "ad";
  const [radioValue, setRadioValue] = useState(1);
  const [adPath, setAdPath] = useState([]);
  const [showAdv, setShowAdv] = useState(false);
  const [count, setCount] = useState(0);

  const updateAdScale = useCallback(() => {
    const width = window.innerWidth;
    const slotHeight = getSlotHeight(width);
    document.documentElement.style.setProperty("--ad-slot-height", `${slotHeight}px`);

    document.querySelectorAll(".advert-wrapper").forEach((wrapper) => {
      const container =
        wrapper.closest(
          ".ad-section-centered, [class*='-header'], .topSectionWrap, .googleAddWrap"
        ) || wrapper.parentElement;
      const availableWidth = container?.clientWidth || wrapper.clientWidth || width;
      const scale = Math.min(1, Math.max(0.32, availableWidth / 970));
      wrapper.style.setProperty("--ad-scale", String(scale));
    });
  }, []);

  useEffect(() => {
    let googleAddApiUrl = "";
    if (userData?.role === Roles.STUDENT_NAME || userData?.role === Roles.PARENT_NAME) {
      googleAddApiUrl = `${API_URL}/api/student/googleads/`;
    }

    if (!googleAddApiUrl) return;

    fetch(googleAddApiUrl, {
      method: "GET",
      headers: { "x-authorization": `Bearer ${token}` },
    })
      .then((response) => response.json())
      .then((data) => {
        const list = Array.isArray(data?.adv_detail)
          ? data.adv_detail
              .filter((item) => item?.status === "active" && item?.path)
              .map((item) => item.path)
          : [];
        setAdPath(list);
        setShowAdv(list.length > 0);
        setCount(0);
      });
  }, [API_URL, token, userData?.role]);

  useEffect(() => {
    updateAdScale();
    window.addEventListener("resize", updateAdScale);
    return () => window.removeEventListener("resize", updateAdScale);
  }, [updateAdScale]);

  useEffect(() => {
    if (!showAdv) return undefined;

    updateAdScale();
    const observer = new ResizeObserver(updateAdScale);
    document.querySelectorAll(".advert-wrapper").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [showAdv, adPath.length, updateAdScale]);

  useEffect(() => {
    setRadioValue(`ad${count + 1}`);
  }, [count]);

  useEffect(() => {
    if (!adPath || adPath.length <= 1) return undefined;
    const interval = setInterval(() => {
      setCount((prev) => (prev + 1) % adPath.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [adPath.length]);

  useEffect(() => {
    if (count >= adPath.length && adPath.length > 0) {
      setCount(0);
    }
  }, [adPath.length, count]);

  if (!showAdv) {
    return null;
  }

  return (
    <div className="advert-wrapper">
      <div id={adDivId} className="advSlider adSize">
        {adPath[count] && (
          <GPT
            adUnitPath={adPath[count]}
            slotSize={[970, 250]}
            sizeMapping={[
              { viewport: [0, 0], slot: [320, 50] },
              { viewport: [480, 0], slot: [468, 60] },
              { viewport: [768, 0], slot: [728, 90] },
              { viewport: [992, 0], slot: [970, 250] },
            ]}
          />
        )}
      </div>
      {adPath.length > 1 && (
        <div className="ad-dots-container">
          {adPath.map((_, i) => (
            <label key={i} className="ad-dot-label">
              <input
                type="radio"
                name="adDots"
                value={i + 1}
                checked={radioValue === `ad${i + 1}`}
                onChange={() => {
                  setRadioValue(`ad${i + 1}`);
                  setCount(i);
                }}
              />
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

export default Advert;
